import * as _ from 'lodash';

export class VariaveisControleGrid {
    totalPaginas: number;
    totalRegistros: number;
    paginaAtual: number;
    registrosPorPagina: number;
    bloquearPaginaAnterior: boolean;
    bloquearPaginaProxima: boolean;
    labelPaginacao: string;
    campoOrdenacao: string;
    ordenacaoDirecao: string; // asc ou desc
    textoBuscaTextual: string;

    constructor(campoOrdenacao: string) {
        this.resetar(campoOrdenacao);
    }

    private resetar(campoOrdenacao) {
        this.totalPaginas = 0;
        this.totalRegistros = 0;
        this.paginaAtual = 0;
        this.registrosPorPagina = 10;
        this.bloquearPaginaAnterior = true;
        this.bloquearPaginaProxima = true;
        this.labelPaginacao = '';
        this.campoOrdenacao = campoOrdenacao;
        this.ordenacaoDirecao = 'asc';
        this.textoBuscaTextual = '';
    }
}

export class ResultadoBuscaGridModel {
    totalRegistros: number;
    totalPaginas: number;
    lista: any[];

    constructor(filtros: FiltroBuscaGridModel, lista = []) {
        this.tratarResultadoConformeFiltros(filtros, lista);
    }

    tratarResultadoConformeFiltros(filtros: FiltroBuscaGridModel, listaOriginal) {
        let resultado: any[] = [];
        let totalRegistros = 0;
        let totalPaginas = 0;
        if (listaOriginal.length > 0) {
            if (filtros.atributoOrdenacao.length > 0) {
                listaOriginal = _.orderBy(listaOriginal, [filtros.atributoOrdenacao], [filtros.direcaoOrdenacao]);
            }
            totalRegistros = listaOriginal.length;
            totalPaginas = Math.ceil(totalRegistros / filtros.registrosPorPagina);
            totalPaginas = totalPaginas > 1 ?  totalPaginas - 1 : totalPaginas;
            if (filtros.paginaAtual <= totalPaginas) {
                if (totalRegistros > filtros.registrosPorPagina) {
                    const skip = filtros.paginaAtual === 0 ? 0 : ((filtros.paginaAtual * filtros.registrosPorPagina));
                    let skipFinal = skip + filtros.registrosPorPagina;
                    skipFinal = skipFinal > totalRegistros ? totalRegistros : skipFinal;
                    resultado = listaOriginal.slice(skip, skipFinal);
                } else {
                    resultado = listaOriginal;
                }
            }
        }
        this.totalRegistros = totalRegistros;
        this.totalPaginas = totalPaginas;
        this.lista = resultado;
    }
}

export class FiltroBuscaGridModel {
    textoBuscaTextual: string;
    paginaAtual: number;
    registrosPorPagina: number;
    atributoOrdenacao: string;
    direcaoOrdenacao: string;

    constructor(variaveis: VariaveisControleGrid) {
        this.textoBuscaTextual = variaveis.textoBuscaTextual;
        this.paginaAtual = variaveis.paginaAtual;
        this.registrosPorPagina = variaveis.registrosPorPagina;
        this.atributoOrdenacao = variaveis.campoOrdenacao;
        this.direcaoOrdenacao = variaveis.ordenacaoDirecao;
    }
}
